import React from "react";
import { IconButton as MuiIconButton } from "@mui/material";

interface IconButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  ariaLabel: string;
}

const HPIconButton: React.FC<IconButtonProps> = ({
  children,
  onClick,
  className = "",
  ariaLabel,
}) => {
  return (
    <MuiIconButton
      onClick={onClick}
      className={`p-1 text-hp-text-day-primary [&>.MuiSvgIcon-root]:text-base ${className}`}
      aria-label={ariaLabel}
    >
      {children}
    </MuiIconButton>
  );
};

export default HPIconButton;
